<template lang="pug">
    v-card
        v-card-title.d-flex.justify-center.py-6(style='color:#222222; font-weight:700; font-size:20px;') {{ title }}
        v-card-text.pt-0.px-6.pb-4
            .mb-4(v-if='description' style='color:#444444; font-size:14px;') {{ description }}
            .mb-3(v-for='(item, index) in items' :key='index')
                .mb-1(v-if='item.label' style='color:#757575; font-size:13px; font-weight:500;') {{ item.label }}
                .d-flex.align-center
                    .copyable-value.flex-grow-1(:title='item.value') {{ item.value }}
                    v-btn.ml-2.flex-shrink-0(
                        :ripple='false'
                        outlined
                        small
                        height='36'
                        color='#14C6DE'
                        @click='onCopy(item.value, index)'
                    )
                        v-icon.mr-1(size='16') {{ copiedIndex === index ? 'mdi-check' : 'mdi-content-copy' }}
                        span {{ copiedIndex === index ? $t('GENERAL.COPIED') : $t('GENERAL.COPY') }}
        v-card-actions.px-6.pb-5
            v-row.justify-center(no-gutters)
                v-col(cols='3')
                    v-btn(:ripple='false' @click='onClose' width='100%' height='40' color='#14c6de' depressed dark) {{$t('GENERAL.CLOSE')}}
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            title: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                required: false,
                default: '',
            },
            // [{ label, value }]，可放一筆（重設連結）或多筆（帳號 + 密碼）
            items: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                copiedIndex: -1,
            };
        },
        methods: {
            async onCopy(value, index) {
                // navigator.clipboard 只在 https 或 localhost 可用。
                // 地端客戶常以 http 內網位址開 CRM，此時必須退回 execCommand
                let ok = false;
                if (navigator.clipboard && window.isSecureContext) {
                    try {
                        await navigator.clipboard.writeText(value);
                        ok = true;
                    } catch (e) {
                        ok = false;
                    }
                }
                if (!ok) {
                    ok = this.fallbackCopy(value);
                }
                if (ok) {
                    this.copiedIndex = index;
                    setTimeout(() => { this.copiedIndex = -1; }, 2000);
                }
            },
            fallbackCopy(value) {
                try {
                    const el = document.createElement('textarea');
                    el.value = value;
                    el.setAttribute('readonly', '');
                    el.style.position = 'fixed';
                    el.style.opacity = '0';
                    document.body.appendChild(el);
                    el.select();
                    const ok = document.execCommand('copy');
                    document.body.removeChild(el);
                    return ok;
                } catch (e) {
                    return false;
                }
            },
            onClose() {
                this.$emit('emitCopyableResultDialog', false);
            },
        }
    });
</script>

<style scoped>
/* 連結固定單行、超出以省略號表示（完整值以 title 屬性 hover 可見）。
   user-select: all 仍會選取完整字串而非只有可見部分，所以複製鈕失效時
   使用者依然能手動全選複製。 */
.copyable-value {
    background: #F4F4F4;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    padding: 8px 10px;
    font-size: 13px;
    color: #222222;
    user-select: all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
}
</style>
